import lead_closed_img from "./../../../img/calls_card/lead_closed.svg";
import lead_generated_img from "./../../../img/calls_card/lead_generated.svg";
import existing_merchant_served_img from "./../../../img/calls_card/existing_merchant_served.svg";
import lead_followed_up_img from "./../../../img/calls_card/lead_followed_up_img.svg";

import lead_closed__card_corner_img from "./../../../img/calls_card/lead_closed_card_corner.svg";
import lead_generated__card_corner_img from "./../../../img/calls_card/lead_generated_card_corner.svg";
import existing_merchant_served__card_corner_img from "./../../../img/calls_card/existing_merchant_served_card_corner.svg";
import lead_followed_up__card_corner_img from "./../../../img/calls_card/lead_followed_up_card_corner_img.svg";

const outletTypeClassMap = {
  "MICRO MERCHANT": "blue-type",
  "MERCHANT PLUS LITE B": "navy-blue-type",
  "MERCHANT PLUS LITE A": "purpple-type",
  "MEDIUM MERCHANT": "olive-type",
};

const outcomeClassMap = {
  "EXISTING MERCHANT SERVED": "existing_merchant_served_info",
  "LEAD GENERATED": "lead_generated_info",
  "LEAD FOLLOWED-UP": "lead_followed_up_info",
  "LEAD CLOSED": "lead_closed_info",
};

const outcomeImageMap = {
  "EXISTING MERCHANT SERVED": existing_merchant_served_img,
  "LEAD GENERATED": lead_generated_img,
  "LEAD FOLLOWED-UP": lead_followed_up_img,
  "LEAD CLOSED": lead_closed_img,
};

const callOutcomeCornerImageMap = {
  "EXISTING MERCHANT SERVED": existing_merchant_served__card_corner_img,
  "LEAD GENERATED": lead_generated__card_corner_img,
  "LEAD FOLLOWED-UP": lead_followed_up__card_corner_img,
  "LEAD CLOSED": lead_closed__card_corner_img,
};

export const getOutletTypeClassName = (outletType) => {
  return outletTypeClassMap[outletType.toUpperCase()] || "green-type";
};

export const getOutcomeClassName = (outcome) => {
  return outcomeClassMap[outcome.toUpperCase()] || "";
};

export const getOutcomeImage = (outcome) => {
  return outcomeImageMap[outcome.toUpperCase()] || "";
};

export const getCallOutcomeCornerImage = (outcome) => {
  return callOutcomeCornerImageMap[outcome.toUpperCase()] || "";
};
